module.exports = __webpack_public_path__ + "static/media/sports_club_collage.5ceaea34.jpg";